export default __webpack_public_path__ + "static/media/globe.4b6378c9.png";